import { lightenColor, parseColor } from '@disco/utils/color-utils'

const FADE_AMOUNT = 0.5

export type WaveformColors = { color: string; colorFade: string }

/**
 * Resolves an explicit waveform colour (e.g. the embed `?color=` param) into
 * the played and hover-fade colours. Returns null when the value can't be
 * parsed so the caller falls back to the CSS-variable accent.
 */
export const resolveWaveformColors = (
  color?: string,
): WaveformColors | null => {
  if (!color) return null
  try {
    parseColor(color)
    return { color, colorFade: lightenColor(color, FADE_AMOUNT) }
  } catch {
    return null
  }
}
